import _uniqueId from "lodash/uniqueId";

import { MessageProps } from "semantic-ui-react";
import { IMessageAction } from "../actions/messageActions";

export interface IAppMessage extends Partial<MessageProps> {
    createdAt: Date;
    id: string;
}

export type IIncomingAppMessage = Omit<IAppMessage, "id" | "createdAt">

export const makeAppMessage = (messageProps: Partial<MessageProps>) => {
    return ({
        id: _uniqueId(),
        createdAt: new Date(),
        ...messageProps
    })
}

export const defaultMessageState: IMessageState = {
    messages: {},
    messageList: []
};

export interface IMessageState {
    messages: { [key: string]: IAppMessage | undefined };
    messageList: string[];

};

export default function MessageReducer(state = defaultMessageState, action: IMessageAction) {
    switch (action.type) {

        case "SHOW_NEW_MESSAGE": {
            return {
                ...state,
                messages: {
                    ...state.messages,
                    [action.payload.message.id]: action.payload.message
                },
                messageList: [...state.messageList, action.payload.message.id]
            };
        }

        case "HIDE_MESSAGE": {
            const messageIndex = state.messageList.indexOf(action.payload.messageId);
            if (messageIndex > -1) {
                //  let prevMessages = { ...state.messages };

                return {
                    ...state,
                    messages: {
                        ...state.messages,
                        [action.payload.messageId]: undefined
                    },
                    messageList: [
                        ...state.messageList.slice(0, messageIndex),
                        ...state.messageList.slice(messageIndex + 1)
                    ]
                }
            }
            return state
        }


        default: {
            return state;
        }
    }
}
